import OrdersPageTable from './OrdersPageTable';

export default OrdersPageTable;
